import React from "react";
import "./class.css";

class ClassList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedClass: ""
    };
  }
  componentDidMount() {
    this.setState({ selectedClass: this.props.selectedClass });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedClass !== this.props.selectedClass) {
      this.setState({ selectedClass: this.props.selectedClass });
    }
  }
  gotoClass = () => {
    this.props.gotoclass(this.props.classinfo);
  };

  render() {
    const SelectColor = props => (
      <svg
        width="57"
        height="29"
        viewBox="0 0 57 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.556641"
          width="56.0667"
          height="29"
          fill={this.props.classinfo.dp}
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="57"
          height="29"
        >
          <rect
            x="0.556641"
            width="56.0667"
            height="28.7603"
            fill={this.props.classinfo.dp}
          />
        </mask>
        <g mask="url(#mask0)">
          <ellipse
            opacity="0.25"
            cx="8.58232"
            cy="8.50823"
            rx="19.2879"
            ry="19.2934"
            fill="#222222"
          />
        </g>
      </svg>
    );
    const classes = ["classlist-grid"];
    if (
      this.props.classinfo &&
      this.props.classinfo.name === this.state.selectedClass
    ) {
      classes.push("selected-class");
    }
    return (
      <div className={classes.join(" ")} onClick={this.gotoClass}>
        <div>
          <SelectColor />
        </div>
        <div className="classlist-groupname">{this.props.classinfo.name}</div>
      </div>
    );
  }
}

export default ClassList;
